export default __webpack_public_path__ + "static/media/accomm_img_10.1c98dde5.JPG";